var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticClass: "table",
          attrs: { data: _vm.CONTENT_MAP, size: "mini" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "title", label: "责任方", "min-width": "50" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "supplier", label: "供应商", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.supplier == "inputNum"
                      ? _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            controls: false,
                            placeholder: "请输入",
                            min: 0,
                            max: 100,
                          },
                          on: { blur: _vm.updateItem },
                          model: {
                            value: _vm.submitInfo.supplier,
                            callback: function ($$v) {
                              _vm.$set(_vm.submitInfo, "supplier", $$v)
                            },
                            expression: "submitInfo.supplier",
                          },
                        })
                      : _c("div", [_vm._v(_vm._s(_vm.priceInfo.supplierAmt))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "customer", label: "客户", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.customer == "inputNum"
                      ? _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            controls: false,
                            placeholder: "请输入",
                            min: 0,
                            max: 100,
                          },
                          on: { blur: _vm.updateItem },
                          model: {
                            value: _vm.submitInfo.customer,
                            callback: function ($$v) {
                              _vm.$set(_vm.submitInfo, "customer", $$v)
                            },
                            expression: "submitInfo.customer",
                          },
                        })
                      : _c("div", [_vm._v(_vm._s(_vm.priceInfo.customerAmt))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "platform", label: "平台", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.platform == "inputNum"
                      ? _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            controls: false,
                            placeholder: "请输入",
                            min: 0,
                            max: 100,
                          },
                          on: { blur: _vm.updateItem },
                          model: {
                            value: _vm.submitInfo.platform,
                            callback: function ($$v) {
                              _vm.$set(_vm.submitInfo, "platform", $$v)
                            },
                            expression: "submitInfo.platform",
                          },
                        })
                      : _c("div", [_vm._v(_vm._s(_vm.priceInfo.platformAmt))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "saleCost", label: "售后成本", "min-width": "50" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.saleCost && _vm.detailInfo.saleCost)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }